/**
 * Returns the name of an object's property.
 * @example
 *    class User {
 * 	    username : string;
 *    }

 * 	  const propName = nameof<User>().username;
 */
export function nameof<T extends object>() {
	return new Proxy<T>({} as T, {
		get: (_, prop) => prop,
	});
}
